module.exports = __webpack_public_path__ + "media/images/coupon/img-nomiyoru-d6293a0f537756252d5fe9a2413b2487.png";